import React from 'react';
import { TextInput as RNTextInput } from 'react-native';
import { Text } from '@tamagui/core';
import { YStack } from '@tamagui/stacks';
import {
  getCardBackgroundColor,
  getCardBorderColor,
  getInputBackgroundColor,
  getInputBorderColor,
  CARD_BORDER_RADIUS,
  CARD_PADDING,
  BORDER_RADIUS_SMALL,
  INPUT_PADDING_SMALL,
  FONT_SIZE_MD,
  FONT_SIZE_2XL,
  FONT_SIZE_XS,
  BORDER_WIDTH_THIN,
} from '../constants';

export type BlikPaymentFormProps = {
  isDark: boolean;
  textColor: string;
  subtextColor: string;
  blikCode: string;
  onBlikCodeChange: (text: string) => void;
};

const BlikPaymentForm: React.FC<BlikPaymentFormProps> = React.memo(({
  isDark,
  textColor,
  subtextColor,
  blikCode,
  onBlikCodeChange,
}) => {
  return (
    <YStack
      backgroundColor={getCardBackgroundColor(isDark)}
      borderRadius={CARD_BORDER_RADIUS}
      padding={CARD_PADDING}
      borderWidth={BORDER_WIDTH_THIN}
      borderColor={getCardBorderColor(isDark)}
      space="$3"
    >
      <Text fontSize={FONT_SIZE_MD} fontWeight="600" color={subtextColor}>
        Kod BLIK
      </Text>
      <RNTextInput
        value={blikCode}
        onChangeText={(text) => onBlikCodeChange(text.replace(/\D/g, ''))}
        placeholder=""
        placeholderTextColor={subtextColor}
        keyboardType="number-pad"
        maxLength={6}
        style={{
          backgroundColor: getInputBackgroundColor(isDark),
          borderRadius: BORDER_RADIUS_SMALL,
          padding: INPUT_PADDING_SMALL,
          fontSize: FONT_SIZE_2XL,
          fontWeight: '700',
          textAlign: 'center',
          letterSpacing: 8,
          color: textColor,
          borderWidth: BORDER_WIDTH_THIN,
          borderColor: getInputBorderColor(isDark),
        }}
      />
      <Text fontSize={FONT_SIZE_XS} color={subtextColor} textAlign="center">
        Wpisz 6-cyfrowy kod BLIK z aplikacji bankowej
      </Text>
    </YStack>
  );
});

BlikPaymentForm.displayName = 'BlikPaymentForm';

export default BlikPaymentForm;

